import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../pages/index/index.vue'
import Borrow from '../pages/borrow/borrow.vue'
import Info from '../pages/info/info.vue'
import My from '../pages/my/my.vue'
import Login from '../pages/login/login.vue'
import Contract from '../pages/contract/contract.vue'
import Privacy from '../pages/privacy/privacy.vue'
import Notice from '../pages/notice/notice.vue'
import NoticeDetail from '../pages/notice-detail/notice-detail.vue'
import UserInfo from '../pages/user-info/user-info.vue'
import Code from '../pages/code/code.vue'
import Kefu from '../pages/kefu/kefu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: { requiresAuth: true }
  },
  {
    path: '/borrow',
    name: 'Borrow',
    component: Borrow,
    meta: { requiresAuth: true }
  },
  {
    path: '/info',
    name: 'Info',
    component: Info,
    meta: { requiresAuth: true }
  },
  {
    path: '/my',
    name: 'My',
    component: My,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/contract',
    name: 'Contract',
    component: Contract,
    meta: { requiresAuth: true }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/notice',
    name: 'Notice',
    component: Notice,
    meta: { requiresAuth: true }
  },
  {
    path: '/notice-detail',
    name: 'NoticeDetail',
    component: NoticeDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/user-info',
    name: 'UserInfo',
    component: UserInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: { requiresAuth: true }
  },
  {
    path: '/kefu',
    name: 'Kefu',
    component: Kefu,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('hmd_token') || localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
